export default "/_next/static/images/af/7-afe1a93e5cc29de7f7b7688b03dc9609.jpg";